<template>
  <v-card>
    <v-form @submit.prevent="true" v-model="formValid" autocomplete="off">
      <v-container style="padding-top: 0px; padding-bottom: 0px">
        <v-row align="center">
          <v-col cols="6">
            <v-text-field
              :readonly="readonly"
              required
              variant="underlined"
              :rules="NameRules"
              label="Name"
              v-model="currentChangeCategory.name"
              auto-grow
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :readonly="readonly"
              type="number"
              variant="underlined"
              label="Display Order"
              v-model="currentChangeCategory.displayOrder"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <people-picker
              :checked="facilitatorChecked"
              @blur="facilitatorChecked = true"
              v-model="currentChangeCategory.facilitator"
              :user="currentChangeCategory.facilitator"
              label="Facilitator"
              :readonly="readonly"
              @clear="currentChangeCategory.facilitator = null"
              :rules="facilitatorRules"
            ></people-picker>
          </v-col>
          <v-col cols="12" sm="6">
            <people-picker
              :user="currentChangeCategory.backupFacilitator"
              v-model="currentChangeCategory.backupFacilitator"
              label="Backup Facilitator"
              :readonly="readonly"
              :rules="backupFacilitatorRules"
              @clear="currentChangeCategory.backupFacilitator = null"
            ></people-picker>
          </v-col>
          <v-col cols="12">
            <label>Enabled</label>
            <v-switch
              class="ml-2"
              color="black"
              :readonly="readonly"
              v-model="currentChangeCategory.enabled"
              :label="currentChangeCategory.enabled ? 'Yes' : 'No'"
            ></v-switch>
          </v-col>
          <v-col cols="12" sm="6">
            <span>Approval Process Types ({{ currentChangeCategory.approvalProcessTypes.length }})</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span>MOC Types ({{ currentChangeCategory.mocTypes.length }})</span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <TaskPicker
              :tasks="tasks"
              :readonly="readonly"
              @selectTask="selectTask"
              @deleteTask="deleteSelectedTask"
              :selectedTasks="currentChangeCategory.tasks"
              @onClick="onTaskClick"
              @addTask="onTaskAdd"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="end">
            <v-btn v-if="!readonly" :disabled="!formValid || !currentChangeCategory.facilitator" color="success" @click="save"
              >Save</v-btn
            >
            <v-btn @click="close">Close</v-btn>
            <v-btn v-if="readonly ? false : !currentChangeCategory.id" color="error" variant="flat" @click="deleteChange">Delete</v-btn>
          </v-row>
        </v-card-actions>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
import TaskPicker from '@/components/TaskPicker'

export default {
  name: 'ChangeCategory',
  data() {
    return {
      facilitatorChecked: false,
      minimumNameLength: 1,
      maximumNameLength: 120,
      minimumTranslationLength: 1,
      maximumTranslationLength: 300,
      expanded: false,
      formValid: false,
      currentChangeCategory: this.changeCategory || {}
    }
  },
  methods: {
    save() {
      this.$emit('saveChangeCategory', this.currentChangeCategory)
    },
    close() {
      this.$emit('close')
    },
    addApprovalProcessType() {
      this.$emit('addApprovalProcessType', this.currentChangeCategory)
    },
    addMOCType() {
      this.$emit('addMOCType', this.currentChangeCategory)
    },
    create() {
      this.$emit('submit', this.MOCType)
    },
    handleDeleteMOCType(u) {
      this.$emit('deleteMOCType', this.currentChangeCategory, u)
    },
    handleDeleteApprovalProcessType(u) {
      this.$emit('deleteApprovalProcessType', this.currentChangeCategory, u)
    },
    deleteChange() {
      this.$emit('deleteChange', this.currentChangeCategory)
    },
    selectTask(task) {
      if (!task) return

      this.currentChangeCategory.tasks = (this.currentChangeCategory.tasks || []).filter(t => t !== task.clientID).concat(task.clientID)
    },
    deleteSelectedTask(task) {
      this.currentChangeCategory.tasks = this.currentChangeCategory.tasks.filter(t => t !== task.clientID)
    },
    onTaskClick(task) {
      this.$emit('onTaskClick', task)
    },
    onTaskAdd(search) {
      this.$emit('onTaskAdd', search, this.selectTask)
    }
  },
  computed: {
    NameRules: {
      get: function() {
        return [
          v => !!v || 'Name is required',
          v => (v && v.trim().length >= this.minimumNameLength) || `Minimum length is ${this.minimumNameLength}`,
          v => (v && v.trim().length <= this.maximumNameLength) || `Maximum length is ${this.maximumNameLength}`
        ]
      }
    },
    filteredTypes() {
      return this.existingTypes.filter(x => {
        return this.currentChangeCategory.mocTypes.find(y => y.value === x.value)
      })
    },
    facilitatorRules() {
      return [
        v =>
          v && this.currentChangeCategory.backupFacilitator && v.id === this.currentChangeCategory.backupFacilitator.id
            ? 'Facilitator cannot be the same as backup facilitator'
            : true,
        v => (v && v.id ? true : 'Facilitator is required')
      ]
    },
    backupFacilitatorRules() {
      return [
        v =>
          this.currentChangeCategory.facilitator && v && this.currentChangeCategory.facilitator.id === v.id
            ? 'Backup Facilitator cannot be the same as facilitator'
            : true
      ]
    }
  },
  props: {
    changeCategory: Object,
    existingTypes: Array,
    unchanged: Object,
    tasks: Array,
    readonly: Boolean
  },
  components: {
    PeoplePicker,
    TaskPicker
  }
}
</script>
